import api from './api';
import localStorage from './localStorage';
import util from './util';
import event from './event';
import store from './store';
import Promise from 'bluebird';
import config from './config';
import User from '../models/User';

module.exports = {
    registerWithPhone(username,phone,password){
        return api.register({username,mobile:phone,password});
    },
    loginWithPassword(username,password){
        var _this = this;
        return api.login({mobile:username,password})
            .then(function (obj) {
                _this._setToken(
                    obj.user_session.session,
                    // obj.timeToLive* 1000
                );
                return _this.init();
            });
    },
    loginWithWeChatCode(code){
        var _this = this;
        return api.getSessionWithCode(code).then(obj=>{
            _this._setToken(
                obj.user_session.session,
                // obj.timeToLive* 1000
            );
            return _this.init();
        })
    },

    logout:function (backUrl) {
        var logout = ()=>{
            this._setToken('');
            this.emitEvent('user_logout');
            this.clearEventHistory();
            this.goToLoginPage(backUrl);
        };
        logout();
    },
    isLogined(){
        return this._getToken() && this.getUser();
    },
    clearEventHistory:function () {
        this.emittedEvents = {};
    },
    emittedEvents:{},
    emitEvent:function (name,data) {
        if(this.emittedEvents[name])return;
        event.emit(name,data);
        $(document).trigger(name,data);
        this.emittedEvents[name] = true;
    },
    init:function () {
        var _this = this;
        if(this.isLogined() ){ // if login , good;
            return Promise.resolve();
        }
        if(this._getToken()){ // if token but no User , then getUser
            return this._initWithToken(this._getToken()).then(function () {
                var user = _this.getUser();
                _this.emitEvent('user_login',user);
            });
        }else{ // if no token , fine too.
            return Promise.resolve();
        }
    },
    _initWithToken(token){
        return api.getUser().then(res=>{
            this.setUser(res.user_info);
        })
    },
    setUser(user){
        store.setUser(user);
    },
    getUser(){
        return store.state.user;
    },
    _setToken:function (token,maxAge) {
        // maxAge => ms
        localStorage.set(config.tokenLocalStorageKey,token,{maxAge});
    },
    _getToken:function () {
        return localStorage.get(config.tokenLocalStorageKey);
    },
    goToLoginPage:function (backUrl,code) {
        var url = backUrl || window.location.href.match(/^.*\/\/[^\/]*(\/.*)$/)[1];
        if(url.indexOf('/login')>=0){
            return;
        }
        $router.replace({name:'login',query:{
            callback:url,
            code
        }});
    }
}


// WEBPACK FOOTER //
// src/lib/UserService.js